import { Button, Grid, Modal, Typography } from '@material-ui/core';
import React, { useContext } from 'react';
import styled from 'styled-components';
import Ticket from './Ticket';
import Loader from '../components/Loader';
import TableTickets from './TableTickets';
import ApiService from '../helpers/ApiService';
import ErrorScreen from '../components/ErrorScreen';
import { URLContext } from '../../contexts/URLContext';
import ReactHtmlParser from 'react-html-parser';

const SectionContainer = styled.div`
  padding: 16px;
`;

const Emphasis = styled.span`
  color: var(--secondary);
`;

const ModalResultContainer = styled.div`
  border: unset;
  padding: 24px;
  border-radius: 8px;
  background-color: var(--white);
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 90%;
  max-width: 500px;
  text-align: center;

  &:focus {
    outline: unset;
  }
`;

const ImgModal = styled.img`
  max-height: 120px;
`;

const HomeContent = (props) => {
  const {baseURL, dataLoaded, campaignData} = useContext(URLContext);

  const [ allTickets, setAllTickets ] = React.useState([]);
  const [ ticketsToOpen, setTicketsToOpen ] = React.useState([]);
  const [ loading, setLoading ] = React.useState(false);
  const [ openModal, setOpenModal ] = React.useState(false);
  const [ ticketResult, setTicketResult ] = React.useState([]);
  const [ requestError, setRequestError ] = React.useState(false);
  const [ errorProps, setErrorProps ] = React.useState({});

  const refreshTicketOpened = (ticket, data) => {
    ticket.status = 'opened';
    ticket.prize = data.value;
    setTicketResult(ticket);
  }

  const validateErrorMessage = (result) => {
    switch(result.ticket) {
      case "opened":
        setErrorProps ({
          text: "Opa! Seu Bilhete já foi aberto antes!",
          ticket: result.ticket,
          button: "Recarregar página",
          refresh: true
        })
        break;
      case "invalid":
        setErrorProps ({
          text: "Desculpe, o seu bilhete não é válido!",
          ticket: result.ticket,
          button: "Fechar",
          refresh: false,
        })
        break;
      default:
        setErrorProps ({
          text: "ooops... ocorreu um erro ao tentar resgatar seu bilhete",
          ticket: "Erro",
          button: "Tentar novamente",
          refresh: false,
        })
        break;
    }
  }

  const onBilheteRescue = () => {
    setLoading(true);
    if ("vibrate" in navigator) {
      navigator.vibrate(300);
    }
    
    // CALL API /openTicket
    ApiService.post("/api/v1/ticket/open", { ticket: ticketsToOpen.slice(-1)[0].uuid }).then(( {data} ) => {
      refreshTicketOpened(ticketsToOpen.slice(-1)[0], data);

      let lastItemRemoved = ticketsToOpen.slice(0, -1);
      setTicketsToOpen(lastItemRemoved);
      setLoading(false);
      setOpenModal(true);

    }).catch((error) => {
      console.log("ERRO:", error);
      validateErrorMessage(error.responde ? error.response.data : "");

      setLoading(false);
      setRequestError(true);
    });
  }

  const handleClose = () => {
    setOpenModal(false);
  };

  const errorClose = () => {
    if ( errorProps.refresh ) {
      setLoading(true);
      window.location.reload();
    }
    setRequestError(false);
  }

  React.useEffect(() => {
    if(!dataLoaded && dataLoaded !== undefined) {
      setRequestError(true);
      setErrorProps ({
        text: "Campanha não encontrada.",
        ticket: "",
        button: "",
        refresh: true
      })
    } else {
      setRequestError(false);
    }
  }, [dataLoaded])

  const modalContent = (
    <ModalResultContainer>
      <ImgModal src={ticketResult.prize > 0 ? `${baseURL}win.svg` : `${baseURL}lose.svg`} alt="Resultado!" />
      <Typography variant="h6" component="h4" className="bold-text" align="center" style={{ marginTop: 16, textTransform: "uppercase" }}>
        {ticketResult.prize > 0 ? campaignData.winnerTitle : campaignData.loserTitle }
      </Typography>
      {ticketResult.prize > 0 && (
        <div style={{ display: 'inline-flex' }}>
          <Typography variant="h5" className="bold-text" style={{ paddingTop: 8 }}>R$</Typography>
          <Typography variant="h2" className="bold-text">{ticketResult.prize}</Typography>
          <Typography variant="h5" className="bold-text" style={{ alignSelf: 'flex-end', paddingBottom: 8 }}>,00</Typography>
        </div>
        )}
      <Typography variant="body2" component="p" align="center" gutterBottom style={{ marginTop: 8, lineHeight: 1.2 }}>
        {ticketResult.prize > 0 ? ReactHtmlParser(campaignData.winnerText) : ReactHtmlParser(campaignData.loserText) }
      </Typography>
        <Button
          className="white--text bold-text"
          variant="contained"
          color="secondary"
          style={{ width: "100%", marginTop: 16 }}
          onClick={handleClose}
        >
          {ticketResult.prize > 0 ? "Legal, entendi" : "Entendi"}
        </Button>
    </ModalResultContainer>
  );

  React.useEffect(() => {
    const getAllTickets = props.tickets;
    const checkTicketClosed = ticket => ticket.status === "closed";

    setAllTickets(getAllTickets)
    setTicketsToOpen(getAllTickets.filter(checkTicketClosed));
  },[props.tickets])

  return(
    <Grid container>
      <Grid item xs={12}>
        <SectionContainer>
          <Typography variant="h6" component="h2" className="bold-text" align="center">
            {ticketsToOpen.length === 0 ? (
              <>{campaignData.noTickets}</>
            ) : (
              <>{campaignData.titleBeforeTicket} <Emphasis>{ticketsToOpen.length}</Emphasis> {ticketsToOpen.length !== 1 ? campaignData.titleAfterTicketPlural : campaignData.titleAfterTicket}</>
            )}
          </Typography>
          {ticketsToOpen.length > 0 && (
            <Typography variant="body1" component="p" align="center" gutterBottom>
              {campaignData.subtitleTicket}
            </Typography>
          )}
        </SectionContainer>
      </Grid>
      <Grid item xs={12}>
        <SectionContainer>
          <Ticket
            numTickets={ticketsToOpen.length}
            rescue={onBilheteRescue}
          />
        </SectionContainer>
      </Grid>
      {ticketsToOpen.length === 0 && (
        <Grid item xs={12}>
          <SectionContainer>
            <Typography variant="body2" component="p" align="center" gutterBottom>
              {campaignData.afterTicket}
            </Typography>
          </SectionContainer>
        </Grid>
      )}
      {loading && (
        <Loader />
      )}
      {allTickets.length > 0 && (
        <Grid item xs={12}>
          <SectionContainer>
            <TableTickets tickets={allTickets} />
          </SectionContainer>
        </Grid>
      )}
      <Grid item xs={12}>
        <Typography variant="caption" component="p" align="center" className="primary-light--text" gutterBottom style={{ textTransform: "uppercase", margin: "24px 0" }}>
          {`Certificado de autorização SECAP/ME nº ${campaignData.certificate}`}
        </Typography>
      </Grid>
      <Modal open={openModal} onClose={handleClose}>
        {modalContent}
      </Modal>
      { requestError && (
        <ErrorScreen
          target={errorClose}
          button={errorProps.button}
        >
          {errorProps.text}
        </ErrorScreen>
      ) }
    </Grid>
  );
};

export default HomeContent;